import type { IQuestion } from '../types'
import type { LocaleType } from '@/shared/types'

type CategoryNames = Pick<
  IQuestion,
  'categoryNameRu' | 'categoryNameUzCyr' | 'categoryNameUzLat'
>

export function getQuestionCategoryLabel(
  question: CategoryNames,
  language: string,
): string {
  switch (language as LocaleType) {
    case 'uz':
      return question.categoryNameUzLat
    case 'uz-Cyrl':
      return question.categoryNameUzCyr
    default:
      return question.categoryNameRu
  }
}
